import { Pressable, Text, View } from 'react-native'
import { LogOut } from 'lucide-react-native'
import { useTranslation } from 'react-i18next'
import { Avatar, AvatarInfo } from '@chillout/ui'
import type { AdminAccount } from '../auth/adminAccount'

interface AdminMenuFooterProps {
  adminAccount: AdminAccount
  isFull: boolean
  onSignOut: () => void
}

export function AdminMenuFooter({ adminAccount, isFull, onSignOut }: AdminMenuFooterProps) {
  const { t } = useTranslation()

  if (!isFull) {
    return (
      <View className="border-t border-inverse/20 pt-6">
        <Avatar name={adminAccount.name} email={adminAccount.email} />
        <View className="mt-4 h-12" />
      </View>
    )
  }

  return (
    <View className="-ml-3 -mr-4 border-t border-inverse/20 pt-6 pl-3 pr-4">
      <View className="-ml-3">
        <AvatarInfo name={adminAccount.name} email={adminAccount.email} variant="dark" />
      </View>
      <Pressable
        onPress={onSignOut}
        accessibilityLabel={t('nav.logOut')}
        accessibilityRole="button"
        className="-mx-4 mt-4 h-12 flex-row items-center gap-3 rounded-md px-4"
      >
        <View className="w-5 shrink-0 items-center">
          <LogOut size={20} color={'rgba(255,255,255,0.55)'} strokeWidth={1.8} />
        </View>
        <Text className="text-base font-normal text-inverse/60">{t('nav.logOut')}</Text>
      </Pressable>
    </View>
  )
}
